export const planterModel = {
    label: 'Planteur mangrove',
    tableName: 'mangroPlanter',
    properties: [
        {
            label: 'Code groupe',
            id: 'mangroGroup',
            isForeignKey: true,
            column_name: 'name',
            table_column: 'group_id',
            type: 'text',
            example: 'MG_DIANA_01',
            required: true
        },
        {
            label: 'Nom',
            id: 'lastname',
            type: 'text',
            example: 'RAZAFIMAHATRATRA',
            required: true
        },
        {
            label: 'Prénom',
            id: 'firstname',
            type: 'text',
            example: 'Sitraka',
            required: true
        },
        {
            label: 'Genre',
            id: 'genre',
            type: 'text',
            example: 'Masculin',
            required: true
        },
        {
            label: 'Telephone',
            id: 'phone',
            type: 'text',
            example: '034 00 123 45',
            required: true
        },
        {
            label: "Date d'adhesion",
            id: 'member_since',
            type: 'date',
            example: 'JJ/MM/AAAA', // Corrigé : Format jj/mm/aaaa
            required: true
        },
        {
            label: 'Début de collaboration',
            id: 'collaboration_beginning',
            type: 'date',
            example: 'JJ/MM/AAAA', // Corrigé : Format jj/mm/aaaa
            required: true
        },
        {
            label: 'Date de naissance',
            id: 'dob',
            type: 'date',
            example: 'JJ/MM/AAAA', // Corrigé : Format jj/mm/aaaa
            required: true
        },
        {
            label: 'CIN',
            id: 'cin_number',
            type: 'text',
            example: '101 202 303 405',
            required: true
        },
        {
            label: 'Activité',
            id: 'activity',
            type: 'text',
            example: 'Pêcheur',
            required: true
        },
        {
            label: 'Adresse',
            id: 'address',
            type: 'text',
            example: 'Lot II M 45 Analamahitsy',
            required: true
        },
        {
            label: 'Catégorie',
            id: 'category',
            type: 'text',
            example: 'Permanent',
            required: true
        }
    ]
}
